import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { GetRenewalRange } from '@/graphql/contracts/_generated_/getRenewalRange.query';
import GetRenewalRangeQuery from '@/graphql/contracts/getRenewalRange.query.gql';


export function getRenewalRange(): GetRenewalRange['renewalRange'] {
  const result = apolloClientContracts.readQuery<GetRenewalRange>({
    query: GetRenewalRangeQuery
  });

  if(!result) {
    throw new Error('Can\'t get Renewal Range');
  }

  return result.renewalRange;
}
